<template>
  <div class="container-warp">
    <div class="main">
      <!-- 组件1：顶部用户信息 -->
      <UserHeader :username="userName"
                  :userCode="idCard" />

      <!-- 组件2：待参加考试已参加考试组件 -->
      <ExamStatus />

      <!-- 组件3：页面导航按钮 -->
      <NavigationButtons />

      <!-- 组件4：练习情况统计 -->
      <PracticeStats />

      <!-- 组件5：考试情况统计 -->
      <ExamStats />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UserHeader from './components/user-header.vue'
import ExamStatus from './components/exam-status.vue'
import NavigationButtons from './components/navigation-buttons.vue'
import PracticeStats from './components/practice-stats.vue'
import ExamStats from './components/exam-stats.vue'

export default {
  name: "indexPage",
  components: {
    UserHeader,
    ExamStatus,
    NavigationButtons,
    PracticeStats,
    ExamStats
  },
  computed: {
    ...mapGetters(['userName', 'idCard']),
  },
created() { 
    history.pushState(null, '', location.href)
    window.addEventListener('popstate', this.preventBack)
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.preventBack)
  },
  methods: {
     preventBack(){
      // 阻止返回，停留在当前页
      history.pushState(null, '', location.href)
    }
  },
};
</script>

<style lang="less" scoped>
.container-warp {
  padding: 0;
  background: linear-gradient(
    180deg,
    #1989fa 0%,
    #1989fa 160px,
    #f4f6fa 160px,
    #f4f6fa 100%
  );
}
.main {
  padding-bottom: 6px;
}
</style>
